import { isFinite } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import { LocaleService, ContentZonesService } from '@sm360/widget-commons-core-services';

import { CURRENCY_0 } from 'commons-vehicle/constants/currencyFormats.js';
import PriceSkeleton from './PriceSkeleton.jsx';

const CONTENT_ZONE_GROUP = {
    LISTING: 'widget.listing.used',
    VDP: {
        NEW: 'widget.build.and.buy',
        USED: 'widget.vdp.used',
    },
};

const getSellingPriceLabel = () => {
    const contentZoneName = 'selling.price.label';
    let sellingPriceLabel = ContentZonesService.getContentZone(CONTENT_ZONE_GROUP.LISTING, contentZoneName);

    if (!sellingPriceLabel || !sellingPriceLabel.getText()) {
        sellingPriceLabel =
            ContentZonesService.getContentZone(CONTENT_ZONE_GROUP.VDP.NEW, contentZoneName) ||
            ContentZonesService.getContentZone(CONTENT_ZONE_GROUP.VDP.USED, contentZoneName);
    }

    return (sellingPriceLabel && sellingPriceLabel.getText()) || LocaleService.t('VEHICLE_TILE.PRICE');
};

const Price = ({ amount, retail, taxesDisclaimer, includedDisclaimer, loading }) => {
    if (loading) return <PriceSkeleton sellingPriceLabel={getSellingPriceLabel()} />;

    return (
        <div className="listing-tile-all-price">
            <div className="listing-tile-all-price-title sr-text">
                <div className="is-bold">{getSellingPriceLabel()}</div>
                {includedDisclaimer && <div className="disclaimer-included is-light">{includedDisclaimer}</div>}
            </div>
            <div className="listing-tile-all-price-info">
                {retail > 0 &&
                    retail > amount && (
                        <p className="listing-tile-all-price-retails rebated">{LocaleService.l(retail, CURRENCY_0)}</p>
                    )}
                <div className="price is-bold is-price">{isFinite(amount) && LocaleService.l(amount, CURRENCY_0)}</div>
                {taxesDisclaimer && <div className="disclaimer-price is-light">{taxesDisclaimer}</div>}
            </div>
        </div>
    );
};

Price.defaultProps = {
    retail: 0,
    taxesDisclaimer: '',
    includedDisclaimer: '',
    loading: false,
};

Price.propTypes = {
    amount: PropTypes.number.isRequired,
    taxesDisclaimer: PropTypes.string.isRequired,
    retail: PropTypes.number,
    includedDisclaimer: PropTypes.string,
    loading: PropTypes.bool,
};

Price.displayName = 'Price';

export default Price;
